export const STUDY_INSIGHTS_AWAITING_SAMPLES = 'AWAITING_SAMPLES';
export const STUDY_INSIGHTS_CDC_TIER_1_RESULTS_BREAKDOWN_KEY = 'CDC_TIER_1_RESULTS_BREAKDOWN';
export const STUDY_INSIGHTS_CONSENT_STATUS = 'CONSENT_STATUS';
export const STUDY_INSIGHTS_CONSENTED_PARTICIPANTS_CHART = 'CONSENTED_PARTICIPANTS_CHART';
export const STUDY_INSIGHTS_CONSENTED_PARTICIPANTS_DATA = 'CONSENTED_PARTICIPANTS_DATA';
export const STUDY_INSIGHTS_DEMOGRAPHICS_QUERY_KEY = 'DEMOGRAPHICS';
export const STUDY_INSIGHTS_EDIT_GOALS = 'EDIT_GOALS';
export const STUDY_INSIGHTS_INTERESTED_PARTICIPANTS_CHART = 'INTERESTED_PARTICIPANTS_CHART';
export const STUDY_INSIGHTS_PARTICIPANTS_BY_COUNTIES = 'PARTICIPANTS_BY_COUNTIES';
export const STUDY_INSIGHTS_RESULTS_TRACKING_OVERVIEW_QUERY_KEY = 'RESULTS_TRACKING_OVERVIEW';
export const STUDY_INSIGHTS_SAMPLE_TRACKING_QUERY_KEY = 'SAMPLE_TRACKING';
export const STUDY_INSIGHTS_SEQUENCED_SAMPLES = 'SEQUENCED_SAMPLES';
export const STUDY_INSIGHTS_SEQUENCED_SAMPLES_OVERVIEW_QUERY_KEY = 'SAMPLES_SEQUENCED_OVERVIEW';
export const STUDY_INSIGHTS_TOTAL_CONSENTED = 'TOTAL_CONSENTED';
export const STUDY_INSIGHTS_CONVERSION_RATE = 'CONVERSION_RATE';
export const STUDY_INSIGHTS_CAMPAIGN_TRACKING_OVERVIEW = 'CAMPAIGN_TRACKING_OVERVIEW';
export const PARTICIPANT_RECRUITMENT_LIST_CAMPAIGNS = 'LIST_CAMPAIGNS';
export const STUDY_INSIGHTS_KIT_FAILURE_REASON_QUERY_KEY = 'KIT_FAILURE_REASON';
